import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

import {
  User,
  FileCheck,
  Building2,
  ShieldCheck,
  ClipboardList,
  BarChart3,
  KanbanSquare,
  FileText,
  PlusCircle,
  Home,
  CreditCard,
  Route,
  FileWarning,
  Upload,
  Users,
} from 'lucide-react';

interface MenuItem {
  label: string;
  path: string;
  icon: React.ElementType;
  permission?: string;
}

const principal: MenuItem[] = [
  {
    label: 'Fluxo Piloto',
    path: '/piloto/fluxo',
    icon: Route,
    permission: 'empresas.visualizar',
  },
  {
    label: 'Perfil',
    path: '/perfil',
    icon: User,
  },
  {
    label: 'Certificados',
    path: '/certificados',
    icon: FileCheck,
    permission: 'leitos.visualizar_certificados',
  },
];

const backoffice: MenuItem[] = [
  {
    label: 'Aprovação Empresas',
    path: '/backoffice/aprovacao-empresas',
    icon: Building2,
    permission: 'empresas.aprovar',
  },
  {
    label: 'Gestão Empresas',
    path: '/backoffice/gestao-empresas',
    icon: Building2,
    permission: 'empresas.visualizar',
  },
  {
    label: 'Acessos Empresas',
    path: '/backoffice/acessos-empresas',
    icon: Users,
    permission: 'usuarios.gerir',
  },
  {
    label: 'Dashboard Licenças',
    path: '/backoffice/dashboard-licencas',
    icon: BarChart3,
    permission: 'documentos.visualizar',
  },
  {
    label: 'Alertas Documentos',
    path: '/backoffice/alertas-documentos',
    icon: FileWarning,
    permission: 'documentos.visualizar',
  },
  {
    label: 'Validação Licenças',
    path: '/backoffice/validacao-licencas',
    icon: ShieldCheck,
    permission: 'documentos.validar',
  },
  {
    label: 'Workflow',
    path: '/backoffice/workflow',
    icon: ClipboardList,
    permission: 'validacoes.concluir',
  },
];

const operacional: MenuItem[] = [
  {
    label: 'Leitos',
    path: '/operacional/leitos',
    icon: ClipboardList,
    permission: 'leitos.visualizar',
  },
  {
    label: 'Dashboard',
    path: '/operacional/dashboard',
    icon: Home,
    permission: 'auditoria.consultar',
  },
  {
    label: 'Monitoramento MTR',
    path: '/operacional/mtrs',
    icon: KanbanSquare,
    permission: 'mtr.criar',
  },
  {
    label: 'Novo MTR',
    path: '/operacional/mtrs/novo',
    icon: PlusCircle,
    permission: 'mtr.criar',
  },
  {
    label: 'Importar MTR',
    path: '/operacional/mtrs/importacao',
    icon: Upload,
    permission: 'mtr.criar',
  },
  {
    label: 'Relatórios',
    path: '/operacional/relatorios',
    icon: FileText,
    permission: 'auditoria.consultar',
  },

];

  const Checkout: MenuItem[] = [
  {
    label: 'Compra de Créditos',
    path: '/Checkout/creditos',
    icon: CreditCard,
    permission: 'creditos.ajustar',
  },
];

const renderGroup = (
  title: string,
  items: MenuItem[],
  canSee: (item: MenuItem) => boolean
) => (
  <div className="space-y-1">
    <h3 className="px-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
      {title}
    </h3>

    {items.filter(canSee).map((item) => {
      const Icon = item.icon;

      return (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all ${
              isActive
                ? 'bg-emerald-600 text-white shadow'
                : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
            }`
          }
        >
          <Icon size={18} />
          <span>{item.label}</span>
        </NavLink>
      );
    })}
  </div>
);

const Sidebar: React.FC = () => {
  const { hasPermission } = useAuth();
  const canSee = (item: MenuItem): boolean =>
    !item.permission || hasPermission(item.permission);

  return (
    <aside className="w-72 bg-white border-r border-gray-200 h-screen sticky top-0 overflow-y-auto">
      <div className="px-6 py-5 border-b border-gray-200">
        <h1 className="text-2xl font-bold text-emerald-700">
          Gestão RSS
        </h1>

        <p className="text-sm text-gray-500 mt-1">
          Plataforma Operacional
        </p>
      </div>

      <div className="p-4 space-y-6">
        {renderGroup('Principal', principal, canSee)}
        {renderGroup('Backoffice', backoffice, canSee)}
        {renderGroup('Operacional', operacional, canSee)}
        {renderGroup('Checkout', Checkout, canSee)}
      </div>
    </aside>
  );
};

export default Sidebar;
